export default function localImg(src) {
	return `/images/${src}`;
}